import * as React from "react";
import {useContext, useState} from "react";
import AuthContext from "../contexts/AuthContext";
import {useNavigate} from "react-router-dom";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
//import Checkbox from '@mui/material/Checkbox';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
//import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import {styled} from '@mui/material/styles';
import MuiCard from '@mui/material/Card';
//import Lottie from "lottie-react";
//import anime3 from '../animations/anime3.json';

const Card = styled(MuiCard)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    boxShadow:
        'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    [theme.breakpoints.up('sm')]: {
        width: '450px',
    },
    ...theme.applyStyles('dark', {
        boxShadow:
            'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
}));

const SignUpContainer = styled(Stack)(({theme}) => ({
    /*height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',*/
    minHeight: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4),
    },
    '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        zIndex: -1,
        inset: 0,
        backgroundImage:
            'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
        backgroundRepeat: 'no-repeat',
        ...theme.applyStyles('dark', {
            backgroundImage:
                'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
        }),
    },
}));

const SigninPage = () => {
    //const [email, setEmail] = useState("");
    //const [password, setPassword] = useState("");
    //const [loading, setLoading] = useState(false);
    const [error_, setError] = useState("");
    const {login} = useContext(AuthContext);
    const navigate = useNavigate();
    const [emailError, setEmailError] = React.useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
    const [passwordError, setPasswordError] = React.useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');

    const validateInputs = () => {
        const email = document.getElementById('email');
        const password = document.getElementById('password');
        //const name = document.getElementById('name');

        let isValid = true;

        if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
            setEmailError(true);
            setEmailErrorMessage('Please enter a valid email address.');
            isValid = false;
        } else {
            setEmailError(false);
            setEmailErrorMessage('');
        }

        if (!password.value || password.value.length < 6) {
            setPasswordError(true);
            setPasswordErrorMessage('Password must be at least 6 characters long.');
            isValid = false;
        } else {
            setPasswordError(false);
            setPasswordErrorMessage('');
        }


        return isValid;
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!validateInputs()) return;

        const data = new FormData(event.currentTarget);


        const payload = {
            email: data.get('email'),
            password: data.get('password')
        };


        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/signIn`, {
                method: 'POST', // POST olmalı, GET değil
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Signin failed");
            }

            // TODO After successful sign-in, you can store the token in local storage or context
            const data = await response.json();
            const email = document.getElementById('email').value;
            const token = data.token; // Assuming the token is returned in the response
            login(email, token); // Assuming you have a login function in your AuthContext





            // Başarılı giriş sonrası yönlendirme
            navigate("/home");

        } catch (error) {

            setError("Signin failed: " + error.message);
            console.error(error_);
            setPasswordError(true);
            setPasswordErrorMessage(error.message);
        }
    };


    return (
        <div className="SigninPage">
            <CssBaseline enableColorScheme/>
            <SignUpContainer direction="column" justifyContent="space-between">

                <Card variant="outlined">

                    <h2 align={"center"}>Giriş Yap</h2>
                    <p align={"center"} style={{color:'gray'}}>Hoşgeldin. Lütfen bilgilerini gir.</p>
                    <Divider/>
                    {/*
                    <Lottie animationData={anime3} loop={true} className="loading-animation"
                            style={{width: '50%', height: '50%', margin: '-25% auto'}}/>
*/}
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        sx={{display: 'flex', flexDirection: 'column', gap: 2}}
                    >
                        <FormControl>
                            <TextField
                                required
                                fullWidth
                                id="email"
                                placeholder="your@email.com"
                                name="email"
                                autoComplete="email"
                                variant="outlined"
                                error={emailError}
                                helperText={emailErrorMessage}
                                color={passwordError ? 'error' : 'primary'}
                                label={"E-mail"}

                            />
                        </FormControl>
                        <FormControl>
                            <TextField
                                required
                                fullWidth
                                name="password"
                                placeholder="••••••"
                                type="password"
                                id="password"
                                autoComplete="new-password"
                                variant="outlined"
                                error={passwordError}
                                helperText={passwordErrorMessage}
                                color={passwordError ? 'error' : 'primary'}
                                label={"Şifre"}
                            />
                        </FormControl>

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            onClick={validateInputs}
                        >
                            Giriş Yap
                        </Button>
                    </Box>
                    <Divider/>

                    <p align={"center"} style={{color:'gray'}}>
                        Henüz hesabın yok mu? <a href="/signup">Kayıt Ol</a>
                    </p>
                </Card>
            </SignUpContainer>

        </div>

    );
};

export default SigninPage;
